import { Box, useTheme } from "@material-ui/core";
import MappedComponent from "../../../../components/mapped-components/MappedComponent";
import { DocumentStatus } from "../../../../models/generated/graphql";

const useStatusAttributes = (status: DocumentStatus): string => {
	const { palette } = useTheme();
	switch (status) {
		case DocumentStatus.WorkingDraft:
			return palette.grey[500];
		case DocumentStatus.InReview:
		case DocumentStatus.InApproval:
			return palette.warning.main;
		case DocumentStatus.Issued:
			return palette.secondary.main;
		case DocumentStatus.Settled:
			return palette.grey[500];
		default:
			throw new Error("no matching color");
	}
};

export default function StatusColumn(props: { status: DocumentStatus; text?: string }) {
	const { status, text } = props;
	const color = useStatusAttributes(status);

	return (
		<Box color={color}>
			<MappedComponent component="InvoiceStatusComponent" props={{ status: status, text: text || "" }} />
		</Box>
	);
}
